import { GetQuoteFilterByStatus } from "@covertree/agent-portal-graphql";

export const mapQuoteStatus = (quoteStatus?: GetQuoteFilterByStatus | null) => {
  if (!quoteStatus) return "Unknown";

  switch (quoteStatus) {
    case GetQuoteFilterByStatus.Valid:
      return "Valid";
    case GetQuoteFilterByStatus.Pending:
      return "Pending-UW";
    case GetQuoteFilterByStatus.Expired:
      return "Expired";
    default:
      return quoteStatus;
  }
};
